<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Bildkort med overlay
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Bildkort med gradientöverlager längst ned. Titel, beskrivning och länk
      visas ovanpå bilden. Används på kategorisidan för alla kortstorlekar.
    </p>

    <PreviewBox label="Overlay-kort — hero-variant">
      <div
        class="relative rounded-[24px] overflow-hidden cursor-pointer w-full max-w-[360px]"
        style="aspect-ratio: 3/4"
      >
        <!-- Gradient placeholder -->
        <div
          class="absolute inset-0"
          style="
            background: linear-gradient(
              135deg,
              #d1faf5 0%,
              #99f0e5 40%,
              #14b8a6 100%
            );
          "
        />
        <!-- Overlay gradient -->
        <div
          class="absolute inset-0 flex flex-col justify-end p-5"
          style="
            background: linear-gradient(
              to top,
              rgba(0, 0, 0, 0.7) 0%,
              rgba(0, 0, 0, 0) 50%
            );
          "
        >
          <h3
            class="font-[Poppins] font-bold text-[18px] text-white leading-[1.3] mb-1 m-0"
          >
            Surdegsbröd med frön och nötter
          </h3>
          <p class="text-[14px] text-white/90 mb-2 line-clamp-2">
            Alla recept inom bakverk samlade på ett ställe.
          </p>
          <span
            class="inline-flex items-center gap-2 text-teal-400 font-bold text-sm"
          >
            Visa recept <ArrowRight :size="14" />
          </span>
        </div>
      </div>
    </PreviewBox>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { ArrowRight } from "lucide-vue-next";
import PreviewBox from "../components/PreviewBox.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<!-- Bildkort med overlay -->
<Link :href="cat.path"
  class="relative overflow-hidden rounded-3xl block"
  style="height: clamp(180px, 25vw, 310px); text-decoration: none">
  <img :src="cat.cover_image_url" :alt="cat.name"
    class="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
  <div v-else class="w-full h-full bg-teal-100" />
  <!-- Gradient overlay -->
  <div class="absolute inset-0 flex flex-col justify-end p-4 md:p-5"
    style="background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 50%)">
    <div>
      <h3 class="font-[Poppins] font-bold text-white mb-1"
        style="font-size: clamp(14px, 2vw, 20px)">{{ cat.name }}</h3>
      <p class="text-[14px] text-white/90 mb-2 line-clamp-2">
        {{ cat.subtitle || \`Alla recept inom \${cat.name.toLowerCase()} samlade på ett ställe.\` }}
      </p>
      <span class="inline-flex items-center gap-2 text-teal-400 font-bold text-[12px]">
        Visa recept <ArrowRight :size="12" />
      </span>
    </div>
  </div>
</Link>`;
const cssCode = `/* Kort */
border-radius: 24px;   /* rounded-[24px] */
overflow: hidden;

/* Gradient overlay */
height: 65%;
background: linear-gradient(to top, rgba(25,28,30,0.82) 0%, transparent 100%);

/* Badge */
background: rgba(255,255,255,0.2);
backdrop-filter: blur(6px);
border-radius: 9999px;

/* Titel */
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 18px;
color: white;
line-height: 1.3;`;

const snippetTabs = [{ label: "HTML", code: htmlCode }];
</script>
